var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',[_c('b-row',[_c('b-col',[_c('h2',[_vm._v("Reminders and Alerts")]),_c('h2',[_vm._v("REMINDERS AND ALERTS!!!")])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }